import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './features/store.js';
import App from './App.jsx';
import AccessibilityGuard from './components/common/AccessibilityGuard.jsx';
import { initTrustedTypes } from './security/trustedTypes.js';

import './index.css';
import './i18n';

const ToastContainer = lazy(() =>
  import('react-toastify').then((module) => ({ default: module.ToastContainer }))
);

initTrustedTypes();

const enableDeferredFonts = () => {
  const fontLink = document.getElementById('google-fonts');
  if (!fontLink) return;
  const applyFonts = () => {
    fontLink.media = 'all';
  };

  if (fontLink.sheet) {
    applyFonts();
    return;
  }

  fontLink.addEventListener('load', applyFonts, { once: true });
};

enableDeferredFonts();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <AccessibilityGuard />
      <App />
      <Suspense fallback={null}>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Suspense>
    </Provider>
  </StrictMode>
);
